import { css } from 'linaria';
import tokens from './tokens';
import { ColorValues } from './types';

const borderColorVariants: Record<ColorValues, string> = {
    transparent: css`
        border-color: ${tokens.colors.transparent};
    `,
    white: css`
        border-color: ${tokens.colors.white};
    `,
    black: css`
        border-color: ${tokens.colors.black};
    `,
    gainsboro: css`
        border-color: ${tokens.colors.gainsboro};
    `,
    'grey.3': css`
        border-color: ${tokens.colors['grey.3']};
    `,
    'grey.4': css`
        border-color: ${tokens.colors['grey.4']};
    `,
    'grey.5': css`
        border-color: ${tokens.colors['grey.5']};
    `,
    'grey.6': css`
        border-color: ${tokens.colors['grey.6']};
    `,
    'orange.1': css`
        border-color: ${tokens.colors['orange.1']};
    `,
    'orange.3': css`
        border-color: ${tokens.colors['orange.3']};
    `,
    'orange.4': css`
        border-color: ${tokens.colors['orange.4']};
    `,
    'orange.5': css`
        border-color: ${tokens.colors['orange.5']};
    `,
    'blue.3': css`
        border-color: ${tokens.colors['blue.3']};
    `,
    'blue.4': css`
        border-color: ${tokens.colors['blue.4']};
    `,
    'blue.5': css`
        border-color: ${tokens.colors['blue.5']};
    `,
};

const backgroundColorVariants: Record<ColorValues, string> = {
    transparent: css`
        background-color: ${tokens.colors.transparent};
    `,
    white: css`
        background-color: ${tokens.colors.white};
    `,
    black: css`
        background-color: ${tokens.colors.black};
    `,
    gainsboro: css`
        background-color: ${tokens.colors.gainsboro};
    `,
    'grey.3': css`
        background-color: ${tokens.colors['grey.3']};
    `,
    'grey.4': css`
        background-color: ${tokens.colors['grey.4']};
    `,
    'grey.5': css`
        background-color: ${tokens.colors['grey.5']};
    `,
    'grey.6': css`
        background-color: ${tokens.colors['grey.6']};
    `,
    'orange.1': css`
        background-color: ${tokens.colors['orange.1']};
    `,
    'orange.3': css`
        background-color: ${tokens.colors['orange.3']};
    `,
    'orange.4': css`
        background-color: ${tokens.colors['orange.4']};
    `,
    'orange.5': css`
        background-color: ${tokens.colors['orange.5']};
    `,
    'blue.3': css`
        background-color: ${tokens.colors['blue.3']};
    `,
    'blue.4': css`
        background-color: ${tokens.colors['blue.4']};
    `,
    'blue.5': css`
        background-color: ${tokens.colors['blue.5']};
    `,
};

const colorVariants: Record<ColorValues, string> = {
    transparent: css`
        color: ${tokens.colors.transparent};
    `,
    white: css`
        color: ${tokens.colors.white};
    `,
    black: css`
        color: ${tokens.colors.black};
    `,
    gainsboro: css`
        color: ${tokens.colors.gainsboro};
    `,
    'grey.3': css`
        color: ${tokens.colors['grey.3']};
    `,
    'grey.4': css`
        color: ${tokens.colors['grey.4']};
    `,
    'grey.5': css`
        color: ${tokens.colors['grey.5']};
    `,
    'grey.6': css`
        color: ${tokens.colors['grey.6']};
    `,
    'orange.1': css`
        color: ${tokens.colors['orange.1']};
    `,
    'orange.3': css`
        color: ${tokens.colors['orange.3']};
    `,
    'orange.4': css`
        color: ${tokens.colors['orange.4']};
    `,
    'orange.5': css`
        color: ${tokens.colors['orange.5']};
    `,
    'blue.3': css`
        color: ${tokens.colors['blue.3']};
    `,
    'blue.4': css`
        color: ${tokens.colors['blue.4']};
    `,
    'blue.5': css`
        color: ${tokens.colors['blue.5']};
    `,
};

export default {
    backgroundColorVariants,
    borderColorVariants,
    colorVariants,
};
